import { sumBy } from 'helpers/number'
import { TOrderCargo, TOrderCargoTotal } from 'modules/order/types'
import { OrderCargoInfo } from 'schema'
import { multiply } from 'shared/helpers/number'

/** Форматирует вес для отображения пользователю (гр) */
export const getSummarySeparateWeight = (cargo: Partial<TOrderCargo>[]) =>
  String(sumBy(cargo, ({ amount, weight }) => (amount && weight ? Number(multiply(amount, weight)) : undefined), 3))

/** Форматирует вес для отображения пользователю (кг) */
export const getSummaryTotalWeight = ({ weight }: Partial<TOrderCargoTotal>) => (weight ? String(weight) : undefined)

/** Форматирует объём для отображения пользователю (см³) */
export const getSummarySeparateVolume = (cargo: Partial<TOrderCargo>[]) =>
  String(
    sumBy(cargo, ({ amount, height, length, width }) =>
      amount && height && length && width
        ? Number(multiply(multiply(multiply(amount, height), length), width, 6))
        : undefined
    )
  )

/** Форматирует объём для отображения пользователю (м³) */
export const getSummaryTotalVolume = ({ volume }: Partial<TOrderCargoTotal>) => (volume ? String(volume) : undefined)

type TGetTotalCargoParams = { volume?: string; weight?: string }

/** Получить суммарные параметры заявки (вес, г и объем, см³) */
export const getTotalCargoParams = ({
  cargoType,
  cargo,
  cargoTotal
}: {
  cargo?: TOrderCargo[]
  cargoTotal?: TOrderCargoTotal
  cargoType?: OrderCargoInfo.type
}): TGetTotalCargoParams => {
  const param = {} as unknown as TGetTotalCargoParams

  if (cargoType === OrderCargoInfo.type.SEPARATE && cargo) {
    param.weight = getSummarySeparateWeight(cargo)
    param.volume = getSummarySeparateVolume(cargo)
  }

  if (cargoType === OrderCargoInfo.type.TOTAL && cargoTotal) {
    param.weight = getSummaryTotalWeight(cargoTotal)
    param.volume = getSummaryTotalVolume(cargoTotal)
  }

  return param
}

/** Вычисляет общую объявленную ценность посылки по всем грузоместам (в рублях). */
export const getTotalCargoPrice = (cargo?: Partial<TOrderCargo>[]): undefined | number =>
  sumBy(cargo, ({ amount, price }) => (amount && price ? Number(multiply(amount, price)) : undefined), 2)
